module.exports = __webpack_public_path__ + "img/Grupo 72.09333596.png";